module.exports = __webpack_public_path__ + "img/Empfangen_anywhere_1.94a8070b.png";